import { render, staticRenderFns } from "./AddVendorCategoryComponent.vue?vue&type=template&id=406db318&"
import script from "./AddVendorCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./AddVendorCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports